import React from 'react';
import { LanguageToggle } from './LanguageToggle';

export const Header = ({ language, setLanguage }) => {
  const content = {
    en: {
      home: 'Home',
      products: 'Products',
      delivery: 'Delivery',
      contact: 'Contact'
    },
    gu: {
      home: 'હોમ',
      products: 'વસ્તુઓ',
      delivery: 'ડિલિવરી',
      contact: 'સંપર્ક'
    }
  };

  const t = content[language];

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img 
            src="https://customer-assets.emergentagent.com/job_6d311a70-d8b2-4827-b078-6b13ef0b245b/artifacts/8obibit1_877d2277-d452-4124-a4ed-703d70df9d23.jpeg" 
            alt="U-MART Logo" 
            className="h-12 w-12 object-contain"
          />
          <span className="text-2xl font-bold text-red-600">U-MART</span>
        </div>
        
        <nav className="hidden md:flex items-center gap-6">
          <a href="#home" className="text-gray-700 hover:text-red-600 transition-colors font-medium">{t.home}</a>
          <a href="#products" className="text-gray-700 hover:text-red-600 transition-colors font-medium">{t.products}</a>
          <a href="#delivery" className="text-gray-700 hover:text-red-600 transition-colors font-medium">{t.delivery}</a>
          <a href="#contact" className="text-gray-700 hover:text-red-600 transition-colors font-medium">{t.contact}</a>
        </nav>

        <LanguageToggle language={language} setLanguage={setLanguage} />
      </div>
    </header>
  );
};